import { Button, SingleSelectInput, TextInput } from "@ucl/react-library";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useBoundInput } from "src/hooks/use-bound-input";
import countiesList from "./county-list.json";

export const AddressManualEntry = ({ toggleAddressType }: { toggleAddressType: () => void; }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const addressLine1Props = useBoundInput({ name: "address.addressLine1", control });
  const addressLine2Props = useBoundInput({ name: "address.addressLine2", control });

  const cityProps = useBoundInput({ name: "address.city", control });
  const countyProps = useBoundInput({ name: "address.county", control });
  const postCodeProps = useBoundInput({ name: "address.postCode", control });
  const countryProps = useBoundInput({ name: "address.country", control });

  return (
    <div data-testid={"manualAddressSection"} className={"flex flex-col gap-5 w-full"}>
      <Button type="button" variant="tertiary" onClick={(toggleAddressType)} fullWidthMobile={false} className="!pl-0 !underline self-start !text-primary" >{t("editContactDetails.backToLookup")}</Button>
      <TextInput
        data-testid={"addressLine1"}
        labelProp={{ label: t("editContactDetails.addressLine1") }}
        placeholder=""
        {...addressLine1Props}
      />
      <TextInput
        data-testid={"addressLine2"}
        labelProp={{ label: t("editContactDetails.addressLine2") }}
        placeholder=""
        {...addressLine2Props}
      />
      <div className={"flex flex-row gap-5 "}>
        <TextInput
          data-testid={"city"}
          labelProp={{ label: t("editContactDetails.city") }}
          placeholder=""
          {...cityProps}
          className="flex-1"
        />
        <SingleSelectInput
          data-testid={"county"}
          labelProp={{ label: t("editContactDetails.county") }}
          options={countiesList.counties}
          selected={countyProps.value}
          onOptionSelect={(option) => countyProps.onChange(option.value)}
          className="flex-1"
        />
      </div>
      <div className={"flex flex-row gap-5"}>
        <TextInput
          data-testid={"postcode"}
          labelProp={{ label: t("editContactDetails.postcode") }}
          placeholder=""
          {...postCodeProps}
          className="flex-1"
        />
        <SingleSelectInput
          data-testid={"country"}
          labelProp={{ label: t("editContactDetails.country") }}
          options={[{ label: "United Kingdom", value: "United Kingdom" }]}
          selected={countryProps.value || "United Kingdom"}
          onOptionSelect={(option) => countryProps.onChange(option.value)}
          isDisabled
          className="flex-1"
        />
      </div>
    </div>);
};